
import React, { useEffect, useState, useRef } from "react";
import { Container, Placeholder } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import uniqid from 'uniqid';

import GameTile from "./GameTile";
import ScrollButtons from './ScrollButtons';
import MoreGamesLink from "./MoreGamesLink";
import CategoryTitle from "./CategoryTitle";
// import DailyJackpot from "./DailyJackpot";
// import HourlyJackpot from "./HourlyJackpot";

export default function MustDropJackpotRow({ categoryURL, title, type }) {
    const placeholder = new Array(10).fill(null);
    const country = useSelector((state) => state.globalContent.data.country)
    const categories = useSelector((state) => state.gameCategories.list);
    const category = categories ? (categories[`${categoryURL}-${country.ISOcode}`] || categories[categoryURL]) : null;
    const userLoggedIn = useSelector((state) => state.user.isLoggedIn);
    const user = useSelector((state) => state.user.data);

    const container = useRef(null);

    useEffect(() => { });
    return (
        <Container fluid="lg" className="game-category-container game-row-container section-margin" id={categoryURL}>

            {/* Title */}
            {
                title ? (
                    <CategoryTitle title={title} />
                ) : (
                    <div className="title-placeholder"></div>
                )
            }

            {/* Row */}
            <div className="position-relative">

                <div className="game-row-wrapper must-drop-jackpot-row-wrapper" ref={container}>

                    {
                        type === 'daily' && <DailyJackpot />
                    }

                    {
                        type === 'hourly' && <HourlyJackpot />
                    }

                    {/* Games */}
                    {
                        !category ? placeholder.map(game => <GameTile game={game} key={uniqid()} />) :
                            category.games.map((game, i) => {
                                return <GameTile game={game} key={`${categoryURL}-${game.id}-${i}`} />
                            })
                    }

                </div>

                {/* Scroll */}
                <ScrollButtons container={container} />
            </div>
        </Container>
    );
}


function DailyJackpot() {

    const [amount, setAmount] = useState(0);
    const [timer, setTimer] = useState('');

    function leadingZero(num) {
        num = num.toString();
        while (num.length < 2) num = "0" + num;
        return num;
    }

    useEffect(() => {
        const contributionPerSecond = 0.058719;
        const today = new Date();
        let hours = today.getHours();
        let mimuntes = today.getMinutes();
        let seconds = today.getSeconds();
        let secondsFromStartOfDate = (hours * 60 * 60) + (mimuntes * 60) + seconds;
        let secondsUntilEndOfDate = (24 * 60 * 60) - secondsFromStartOfDate;

        let tempAmount = (Math.round((secondsFromStartOfDate * contributionPerSecond) * 100) / 100).toFixed(2);
        let tempHours = Math.floor((secondsUntilEndOfDate / 60 / 60) % 24);
        let tempMinutes = Math.floor((secondsUntilEndOfDate / 60) % 60);
        let tempSeconds = Math.floor(secondsUntilEndOfDate % 60);

        const timeout = setTimeout(() => {
            (amount === 0 || tempSeconds % 9 === 0) && setAmount(tempAmount);
            setTimer(`${leadingZero(tempHours)}:${leadingZero(tempMinutes)}:${leadingZero(tempSeconds)}`)
        }, 1000);

        return () => {
            clearTimeout(timeout);
        }

    }, [timer])

    return (
        <div className="must-drop-jackpot-tile-container daily-drop">
            <div className="must-drop-content-top">
                <h2 className="tag-xl mb-1 personalized-gold">DAILY JACKPOT</h2>
                <span className="title white-100">${amount}</span>
            </div>
            <div className="must-drop-content-bottom">
                <p className="mb-0 must-drop-timer-lable">DROPS WITHIN</p>
                <p className="mb-0 must-drop-timer" >{timer}</p>
            </div>
        </div>
    )
}

function HourlyJackpot() {
    const [amount, setAmount] = useState(0);
    const [timer, setTimer] = useState('');

    function leadingZero(num) {
        num = num.toString();
        while (num.length < 2) num = "0" + num;
        return num;
    }

    useEffect(() => {
        const contributionPerSecond = 0.273719;
        const today = new Date();
        let mimuntes = today.getMinutes();
        let seconds = today.getSeconds();
        let secondsFromStartOfDate = (mimuntes * 60) + seconds;
        let secondsUntilEndOfDate = (60 * 60) - secondsFromStartOfDate;

        let tempAmount = (Math.round((secondsFromStartOfDate * contributionPerSecond) * 100) / 100).toFixed(2);
        let tempMinutes = Math.floor((secondsUntilEndOfDate / 60) % 60);
        let tempSeconds = Math.floor(secondsUntilEndOfDate % 60);

        const timeout = setTimeout(() => {
            (amount === 0 || tempSeconds % 7 === 0) && setAmount(tempAmount);
            setTimer(`${leadingZero(tempMinutes)}:${leadingZero(tempSeconds)}`)
        }, 1000);

        return () => {
            clearTimeout(timeout);
        }

    }, [timer])

    return (
        <div className="must-drop-jackpot-tile-container hourly-drop">
            <div className="must-drop-content-top">
                <h2 className="tag-xl mb-1 personalized-gold">HOURLY JACKPOT</h2>
                <span className="title white-100">${amount}</span>
            </div>
            <div className="must-drop-content-bottom">
                <p className="mb-0 must-drop-timer-lable">DROPS WITHIN</p>
                <p className="mb-0 must-drop-timer" >{timer}</p>
            </div>
        </div>
    )
}